var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{class:'notif-box ' + _vm.anchor + ' ' + _vm.data.color},[_vm._v("\n  "+_vm._s(_vm.data.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }